import { Pipe, PipeTransform } from '@angular/core';

/** A sent message split into its leading `/command` token and the remaining text. */
export interface SlashParts {
  command: string | null;
  rest: string;
}

/**
 * Splits a rep's message so the assistant transcript can style the leading `/command` it was
 * sent with. Display only — the message is sent verbatim, and the token stays part of `text`.
 * Anything that is not a single leading slash token comes back whole, with `command: null`.
 */
@Pipe({ name: 'novaSlash', standalone: true })
export class NovaSlashPipe implements PipeTransform {
  transform(text: string | null | undefined): SlashParts {
    const token = /^(\/[a-z0-9-]+)([\s\S]*)$/.exec((text ?? '').trimStart());
    return token ? { command: token[1], rest: token[2] } : { command: null, rest: text ?? '' };
  }
}
